'use strict';

module.exports = {
    'lang': 'zh-cn',
    'loading': '加载中...',
    'en-us': {
        'loading': 'Loading...'
    },
    'zh-tw': {
        'loading': '加載中...'
    }
};


//////////////////
// WEBPACK FOOTER
// ./~/bee-loading/build/i18n.js
// module id = 672
// module chunks = 0